import {env} from './env-utils'

export const AppName = () => env.REACT_APP_THEME_NAME

export function getTitle(name?: string) {
  if (!name) return env.REACT_APP_THEME_NAME ?? ''
  return `${name} - ${env.REACT_APP_THEME_NAME}`
}
